import { StatusEgressState } from '@tryiris-ai/common.protojs/agent/v1/agent';
import {
  displayBitrateFromBytes,
  displayResolution,
  displaySizeFromBytes
} from '../output/use-outputting.js';
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { DeviceEgressSelectorType } from '#~/statequery/selectors/device-egress.js';

export const getRecordingConfig = (source: DeviceEgressSelectorType) => {
  const { bps, duration, framerate, width, height, size } = source.egress?.recordingStatus ?? {};

  const sizeInBytes = size ?? 0 * 1024;

  return [
    {
      name: 'Duration',
      duration
    },
    {
      name: 'Memory',
      value: displaySizeFromBytes(sizeInBytes)
    },
    ...(source.type === 'video'
      ? [
          {
            name: 'Resolution',
            value: displayResolution(width ?? 0, height ?? 0)
          }
        ]
      : []),
    {
      name: 'Bitrate',
      value: displayBitrateFromBytes(bps ?? 0)
    },
    ...(source.type === 'video'
      ? [
          {
            name: 'FPS',
            value: Math.round(framerate ?? 0)
          }
        ]
      : [])
  ];
};

export const getErrorMessage = (state: T_Maybe<StatusEgressState>, error?: string | null) => {
  // Prefer specific backend error when available (e.g., codec validation).
  if (
    error !== undefined &&
    error !== null &&
    (state === StatusEgressState.EGRESS_STATE_FAILED ||
      state === StatusEgressState.EGRESS_STATE_FAILED_TO_START)
  ) {
    return error;
  }
  if (state === StatusEgressState.EGRESS_STATE_FAILED) {
    return 'Recording unexpectedly stopped.';
  }
  if (state === StatusEgressState.EGRESS_STATE_FAILED_TO_START) {
    return 'Recording could not be started. Please try again.';
  }
  return undefined;
};
